module.exports = true;


//////////////////
// WEBPACK FOOTER
// /app/~/core-js/library/modules/_library.js
// module id = ../../../../core-js/library/modules/_library.js
// module chunks = 7